module.exports = __webpack_public_path__ + "img/9788981339500.d34397f4.jpg";